import React, { useState } from 'react'
import classNames from 'classnames'
import { CROSS_CLIENT_DEFAULTS, CrossClientDefault, FEATURED_CROSS_CLIENT_DEFAULTS } from '../../Defaults/crossClientDefaults'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientInitLoading } from '../../../../store/crossClient/crossClientLanding'
import './CrossClientLandingDefaults.scss'

export interface CrossClientLandingDefaultsProps {
  selectedCategory: string
  onClick: (crossClientDefault: CrossClientDefault) => void
}

export const CrossClientLandingDefaults: React.FC<CrossClientLandingDefaultsProps> = ({ selectedCategory, onClick }) => {
  const initLoading = useAppSelector(selectCrossClientInitLoading)

  return (
    <div className='d-grid gap-2 justify-content-center align-items-start w-100 cross-client-defaults-grid zocks-mb-2'>
      {(selectedCategory === 'Featured' ? FEATURED_CROSS_CLIENT_DEFAULTS : CROSS_CLIENT_DEFAULTS[selectedCategory]).map((item, index) => (
        <div key={item.id} className={`cross-client-default-grid-item cross-client-landing-default-child-${index}`}>
          <CrossClientLandingDefaultCard crossClientDefault={item} index={index} initLoading={initLoading} onClick={onClick} />
        </div>
      ))}
    </div>
  )
}

interface CrossClientLandingDefaultCardProps {
  crossClientDefault: CrossClientDefault
  index: number
  initLoading: boolean
  onClick: (crossClientDefault: CrossClientDefault) => void
}

const CrossClientLandingDefaultCard: React.FC<CrossClientLandingDefaultCardProps> = ({ crossClientDefault, index, initLoading, onClick }) => {
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <div
      className={classNames('d-flex flex-column align-items-start p-3 gap-3 zocks-border-0.5 border border-1 bg-white h-100 cross-client-transition', {
        'zocks-border-color-gray-200': !hovered,
        'zocks-border-color-primary cross-client-default-card-box-shadow': hovered,
      })}
      role='button'
      onClick={() => {
        if (initLoading) {
          return
        }
        onClick(crossClientDefault)
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {index === 0 && crossClientDefault.title ? <h6>{crossClientDefault.title}</h6> : null}
      <div className='paragraph-medium flex-grow-1'>{crossClientDefault.description}</div>
      <div className='d-flex gap-2 align-items-center'>
        <i className={`bi ${crossClientDefault.icon} fs-6 zocks-text-primary`} />
        <div className='paragraph-small text-uppercase zocks-text-primary medium'>{crossClientDefault.category}</div>
      </div>
    </div>
  )
}
